import type { ProfileCreateRequest } from "@/api/types";
import { platform } from "@/platform";
import { webDevice } from "@/platform/browserKind";
import { storedAcquisition } from "./launch";

/** 첫 프로필 요청에 싣는 유입 정보(AC0-367). 유입이 아직 정해지지 않았으면 빠지고 서버 알림은 미확인으로 표시한다. */
export const signupContext = (): NonNullable<ProfileCreateRequest["signupContext"]> => ({
  ...storedAcquisition(),
  ...(platform.clientKind === "web" ? { webDevice: webDevice() } : {}),
});
